import { Study } from './study.model';
import { StudySearchFilter } from './studySearchFilter.model';
import { StudySearchStrategyDatabase } from './studySearchStrategyDatabase.model';

export class StudySearchStrategy {
  public studySearchStrategyId: number;
  public studyId: number;
  public totalCount: number;
  public keywordScreeningResultAcceptedCount?: number;
  public keywordScreeningResultCount?: number;
  public bdMatrixCount?: number;
  public internetReviewCount?: number;
  public financialReviewCount?: number;
  public masterMatrixCount?: number;

  public booleanLogic: string;
  public isActive = true;
  public includeFunctionBooleanLogic: string;
  public includeProductBooleanLogic: string;
  public excludeBooleanLogic: string;
  public isReviewed: boolean;

  public searchFilters: StudySearchFilter[] = [];

  public searchResults = '';
  public searchResultsCount: number;

  // Study
  public study: Study;
  public searchDate: Date;
  public databaseFullName: string;
  public studySearchStrategyDatabases: StudySearchStrategyDatabase[] = [];

  isConsolidated?: boolean;
  isAllAvailable?: boolean;
  filingTypeId: number;
  public isAdjustmentRecalculationRequired: boolean;
  shareholderIndependencyThreshold: number;
  shareholderIndependencyCriteria: number;

}
